import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Checkbox } from 'primereact/checkbox';
import { useSelector } from 'react-redux';
import { selectCurrentEmpid, selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import { ROLES } from '../../../constants';
import { RevgenExpandedGrid } from './RevgenExpandedGrid';
import { RevgenGridProps } from './type';
import {RevGenSummary} from './RevGenSummary'
import GoalFlag from '../../../assets/GoalFlag.png';


export const RevgenGrid = ({
    selectedTeam,
    revgenList,
    inputMonth,
    inputYear,
    goalRecipient,
}:RevgenGridProps) => {
    const [expandedRows, setExpandedRows] = useState<any>();
    const loggedEmpNum = useSelector(selectCurrentEmpid); 
    const [showRevGenGoalSummary, setShowRevGenGoalSummary] = useState<boolean>(false);
    const [recipentDetails, setRecipientDetails] = useState<any>('')
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);

    useEffect(() => {
        if (selectedTeam === 'myTeamActivity' && revgenList.length > 0 && ROLES.Supervisor.includes(userManagerLevel)) {
            setExpandedRows(revgenList);
        }
    }, [selectedTeam, revgenList]);
    const headerTemplate = (header: string, colorcode: string) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <div
                    className={'headerTemplate'}
                    style={{
                        background: colorcode,
                        borderRadius: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <p style={{ margin: '0px' }}> {header}</p>
                </div>
            </div>
        );
    };

    const renderIcons = (rowData : any, columnName :string) => {
        if (ROLES.Agents.includes(userManagerLevel)) {
            return 'pi pi-pencil';
          } else if (rowData[columnName]) {
            return 'pi pi-pencil';
          } else {
            return 'pi pi-plus';
          }
    }
    const createdBtnTemplate = (rowData: any, columnName: string, dividerColor: string) => {
        const countValue = rowData.goals_created_count;      
        const color = rowData[columnName] ? '#2AA154' : '#3F5765';

        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Button
                        type="button"
                        // icon={ rowData[columnName] ? 'pi pi-pencil' : 'pi pi-plus'}
                        icon = {renderIcons(rowData, columnName)}
                        style={{
                            background: 'transparent',
                            border: `${color} 1px solid`,
                            color: `${color}`,
                            width: '30px',
                            height: '30px',
                        }}
                        onClick={() => {setRecipientDetails(rowData);showDialog()}}
                    />
                </div>
                <div style={{ background: `${dividerColor}`, height: '2px', margin: '10px 5px' }}>&nbsp;</div>
                {rowData.direct_reportees_count !== null && rowData.direct_reportees_count !== 0 ? (
                    <div>
                        {countValue}/{rowData.direct_reportees_count}
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    };
    const reviewedBtnTemplate = (rowData: any) => {
        if (ROLES.SupervisorORManager.includes(rowData.manager_level)) {
            return (
                <div style={{ display: 'flex' ,justifyContent:"center",alignItems:"center"}}>
                    {rowData.direct_reportees_count !== null && rowData.direct_reportees_count !== 0 ? (
                        <div>
                            {rowData.supervisor_discussed_count}/{rowData.direct_reportees_count}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center' }}>
                        <div>
                            <Checkbox checked={rowData.supervisor_discussed} />
                        </div>
                    </div>
                    )}
                </div>
            )
        }
        else {
            return (
                <div style={{ textAlign: 'center' }}>
                    <div>
                        <Checkbox checked={rowData.supervisor_discussed} />
                    </div>
                </div>
            );
        }
    };
    const acknowledgeBtnTemplate = (rowData: any) => {
        if (ROLES.SupervisorORManager.includes(rowData.manager_level)) {
            return (
                <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                    {rowData.direct_reportees_count !== null && rowData.direct_reportees_count !== 0 ? (
                        <div>
                            {rowData.associate_acknowledged_count}/{rowData.direct_reportees_count}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <Checkbox checked={rowData.associate_acknowledged} />
                            </div>
                        </div>
                    )}
                </div>
            )
        }
        else {
            return (
                <div style={{ textAlign: 'center' }}>
                    <div>
                        <Checkbox checked={rowData.associate_acknowledged} />
                    </div>
                </div>
            );
        }
    };
    const monthReviewedBtnTemplate = (rowData: any) => {        
        if (ROLES.SupervisorORManager.includes(rowData.manager_level)) {
            return (
                <div style={{ display: 'flex' ,justifyContent:"center",alignItems:"center"}}>
                    {rowData.direct_reportees_count !== null && rowData.direct_reportees_count !== 0 ? (
                        <div>
                            {rowData.month_end_reviewed_count}/{rowData.direct_reportees_count}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <Checkbox checked={rowData.month_end_reviewed} />
                            </div>
                        </div>
                    )}
                </div>
            )
        }
        else {
            return (
                <div style={{ textAlign: 'center' }}>
                    <div>
                        <Checkbox checked={rowData.month_end_reviewed} />
                    </div>
                </div>
            );
        }
    };
    const employeeHeaderTeamplate = () => {
        return (
            <div className='employee-header'>
                <img src={GoalFlag} alt='revgen' />                
                <span>RevGen Sales Goals</span>               
            </div>
        );
    };
    const allowExpansion = (rowData: any) => {
        if (rowData.direct_reportees_count !== null && rowData.direct_reportees_count > 0) return true;
        else return false;
    };
    const expandDescirption = (rowData: any) => {
        if (rowData.direct_reportees_count !== null && rowData.direct_reportees_count > 0) {
            return <p>Expand to view your team</p>;
        } else return '';
    };
    const rowExpansionTemplate = (rowData:any) => {
        return (
            <div className="revgen-subgriddiv">
                <RevgenExpandedGrid
                    loggedEmpNum={loggedEmpNum}
                    selectedEmployee={rowData.employee_number}
                    inputYear={inputYear}
                    inputMonth={inputMonth}
                    userManagerLevel={rowData.manager_level}
                    goalRecipient={goalRecipient}
                />
            </div>
        );
    };
    const showDialog = () => {
        setShowRevGenGoalSummary(true);
    };

    const closeDialog = (res:boolean) => {
        setShowRevGenGoalSummary(!res)
        // setRecipientDetails('');
    }

    return (
        <>           
            <p style={{ marginTop: '10px', marginLeft: '39%', marginBottom: '0px' }}>
                Select a month and team above, click &quot; <i className="pi pi-plus" /> &quot; to add and
                &quot; <i className="pi pi-pencil" /> &quot; to edit
            </p>
            <div className="row">
                <DataTable
                    value={revgenList}
                    id="revgen-maingrid"
                    rows={5}
                    paginator={revgenList?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    emptyMessage="No records found."
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                >
                    <Column
                        field="employee_name"
                        style={{ width: '12rem' }}
                        header={employeeHeaderTeamplate()} 
                    />
                    <Column
                        header={headerTemplate('Created', '#64D96E')}
                        field="goals_created"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => createdBtnTemplate(rowData, 'goals_created', '#2AA154')}
                    />
                    <Column
                        header={headerTemplate('Supervisor Reviewed', '#3DC149')}
                        field="supervisor_discussed"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => reviewedBtnTemplate(rowData)}
                    />
                    <Column
                        header={headerTemplate('Recipient Acknowledged', '#0D9118')}
                        field="associate_acknowledged"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => acknowledgeBtnTemplate(rowData)}
                    />
                    <Column
                        header={headerTemplate(`Month-end Review`, '#066C0E')}
                        field="month_end_reviewed"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => monthReviewedBtnTemplate(rowData)}
                    />
                    <Column key="expand" expander={allowExpansion} style={{ width: '1rem' }} />
                    {selectedTeam === 'myteamgoals' && (
                        <Column style={{ width: '5rem' }} body={(data) => expandDescirption(data)} />
                    )}
                </DataTable>
            </div>
            {showRevGenGoalSummary &&
                <RevGenSummary
                    recipientDetails={recipentDetails}
                    inputMonth={inputMonth}
                    inputYear={inputYear}
                    visible={showRevGenGoalSummary}                    
                    closeDialog={closeDialog}
                    revgenList={revgenList}

                />
            } 
        </>
    );
};
